<template>
  <div class="users-list">
    <TotalInfoBlock v-if="paginationData?.total" :total="parseInt(paginationData?.total)" />
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <CustomersCard
          v-for="item of items"
          :key="item.id"
          :name="item.title"
          :published-at="item.validityPeriod"
          @clickOnOrder="onClickRow({ id: item.id })"
        />
      </div>
      <SkeletonLoaderCard v-else :table-headers="resolvedTableHeaders" />
    </template>

    <OurTable
      v-else
      :headers="resolvedTableHeaders"
      :items="items"
      :table-fixed="false"
      class="users-list-table"
    />

    <OurPagination
      v-if="isMoreThanOnePage"
      :current-page="paginationData.currentPage"
      :per-page="paginationData.perPage"
      :total="paginationData.total"
      :disabled="isLoading"
      @pageChange="onPageChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomersCard from "@/components/MobileCards/CustomersCard.vue";
import SkeletonLoaderCard from "@/ui/loader/SkeletonLoaderCard.vue";
import TotalInfoBlock from "@/components/TotalInfoBlock.vue";
import { buildSurveyListTableHeaders } from "@/views/settings/survey/index/config/surveyListTableHeaders";

export default {
  name: "SurveyList",
  components: { CustomersCard, SkeletonLoaderCard, TotalInfoBlock },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    paginationData: {
      type: Object,
      default: () => {},
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    headers: {
      type: Array,
      default: null,
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),

    resolvedTableHeaders() {
      if (this.headers) {
        return this.headers;
      }

      return buildSurveyListTableHeaders({
        t: (key) => this.$t(key),
      });
    },

    tableHeaders() {
      return [
        {
          value: "title",
          text: this.$t("survey.title"),
          thClass: "w-[14rem]",
          tdClass: "max-w-[14rem] min-w-[10rem]",
        },
        {
          value: "validityPeriod",
          text: this.$t("survey.validityPeriod"),
          thClass: "w-[14rem]",
          tdClass: "max-w-[16rem] min-w-[12rem]",
        },
        {
          value: "maxShows",
          text: this.$t("survey.maxShows"),
          thClass: "w-[8rem]",
          tdClass: "max-w-[8rem] min-w-[6rem]",
        },
        {
          value: "viewedDealersCount",
          text: this.$t("survey.viewedDealersCount"),
          thClass: "w-[8rem]",
          tdClass: "max-w-[8rem] min-w-[6rem]",
        },
      ];
    },

    isMoreThanOnePage() {
      return this.paginationData.lastPage > 1;
    },

    routePage() {
      return Number.parseInt(this.$route.query.page, 10) || 1;
    },
  },

  watch: {
    routePage(newPage) {
      if (newPage !== this.paginationData.currentPage) {
        this.$emit("pageChange", newPage);
      }
    },
  },

  methods: {
    onPageChange(page) {
      this.$emit("pageChange", page);

      if (page !== this.routePage) {
        const query = { ...this.$route.query };

        delete query.page;

        const nextQuery = page === 1 ? query : { ...query, page };

        this.$router.push({ name: this.$route.name, query: nextQuery });
      }
    },

    onClickRow(row) {
      this.$emit("onClickRow", row.id);
    },
  },
};
</script>
